import { AgentSettingsPanel } from '@/components/settings-page/agent-settings-panel';
import type { AppSettings } from '@/lib/app-settings';

export function AgentsSettingsSection(props: {
  agentIds: AppSettings['agentIds'];
  agentRuntimeOverrides: AppSettings['agentRuntimeOverrides'];
  defaultAgent: string;
  onAgentIdsChange: (value: AppSettings['agentIds']) => void;
  onAgentRuntimeOverridesChange: (value: AppSettings['agentRuntimeOverrides']) => void;
  onDefaultAgentChange: (value: string) => void;
}) {
  return <AgentSettingsPanel {...props} />;
}
